<template>
  <div class="loader">
    <h1 class="loader__title">Zgotujmy razem lepszą Polskę...</h1>
    <img src="@/assets/images/footerbook.png" alt="książka" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9999999;
  background-color: #f8f5f1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__title {
    font-family:"Gothic", "Helvetica", "Consolas", "Arial", sans-serif;
    color: #21397d;
    font-size: 2.5rem;
    margin: 1.5rem auto;
    text-align: center;
    text-transform: uppercase;
    @media (max-width: 1600px) {
      padding-inline: 1rem;
    }

    @media (min-width: 1600px) {
      font-size: 4rem;
      font-weight: 400;
      margin-bottom: 2rem;
    }
  }
}
</style>
